import React, {useEffect, useState} from "react";
import {FileInput, RadioInput, SelectInput, TextInput} from "../../../../../components/input/inputs";
import Modal from "../../../../../components/modal/modal";
import axiosInstance from "../../../../../AxiosInstance";

export default function EditCompanyModal({show, setter, id, rows}) {
    const [form, setForm] = useState({});

    const update = () => {
        let formData = new FormData();
        for(const key in form) {
            formData.append(key, form[key]);
        }

        axiosInstance.put(`company/${form.id}/`, formData).then((response) => {
            window.location.reload();
        });

        setForm({});
    }

    useEffect(() => {
        if(!id) return;
        let found = {...rows.filter((x) => x.id === id)[0]}
        found.active = found.active ? 1 : 0;
        setForm(found);
        console.log(found);
    }, [id]);

    return (
        <Modal size={'lg'} show={show} setter={() => {
            setter(false);
            setForm({});
        }} name={'Editar Empresa'} buttonName={'Guardar'} onClick={update}>
            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Razón Social'} internalName={'name'} form={form} setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'RUC'} internalName={'ruc'} form={form} setForm={setForm}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Nombres'} internalName={'first_name'} form={form} setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Apellidos'} internalName={'last_name'} form={form} setForm={setForm}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Teléfono'} internalName={'phone'} form={form} setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Dirección'} internalName={'address'} form={form} setForm={setForm}/>
                </div>
            </div>

            <TextInput grey={true} name={'Email'} internalName={'email'} form={form} setForm={setForm}/>
            <TextInput grey={true} name={'Descripción'} internalName={'description'} form={form} setForm={setForm}/>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Usuario SOL'} internalName={'sunat_sol_username'} form={form}
                               setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Clave SOL'} internalName={'sunat_sol_password'} form={form}
                               setForm={setForm}/>
                </div>
            </div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Cantidad de Trabajadores'} internalName={'worker_count'} form={form}
                               setForm={setForm} type={'number'}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <SelectInput form={form} setForm={setForm}
                                 options={[{id: 0, name: "Inactivo"}, {id: 1, name: "Activo"}]}
                                 internalName={'active'} grey={true} name={'Estado'}/>
                </div>
            </div>

            <div><b>Conformidad</b></div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Sunat ID'} internalName={'sunat_client_id'} form={form}
                               setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Sunat Secret'} internalName={'sunat_client_secret'} form={form}
                               setForm={setForm}/>
                </div>
            </div>

            <div><b>Estado</b></div>

            <div className={'d-flex justify-content-between'}>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Sunat ID'} internalName={'sunat_client_id_status'} form={form}
                               setForm={setForm}/>
                </div>
                <div style={{
                    flexBasis: '48%'
                }}>
                    <TextInput grey={true} name={'Sunat Secret'} internalName={'sunat_client_secret_status'} form={form}
                               setForm={setForm}/>
                </div>
            </div>

            <div className={'mb-3'}>
                <div style={{color: '#333333CC'}}>Reporte tributario de terceros</div>
                <FileInput form={form} setForm={setForm}
                           name={'Seleccionar archivo “.jpg”, “.png” o “.pdf” (REPORTE TRIBUTARIO DE TERCEROS)'}
                           accept={'.pdf,.jpg,.png'}
                           onChange={(event) => {
                               setForm({
                                   ...form,
                                   "report": event.target.files[0]
                               });
                           }}/>

                <div className={'mt-3'} style={{color: '#333333CC'}}>Adjunta tu DNI (para solicitar Factoring)</div>
                <FileInput form={form} setForm={setForm}
                           name={'Seleccionar archivo “.jpg”, “.png” o “.pdf” menor a 2 MB (ANVERSO)'}
                           accept={'.pdf,.jpg,.png'}
                           onChange={(event) => {
                               setForm({
                                   ...form,
                                   "dni_front": event.target.files[0]
                               });
                           }}/>
                <FileInput form={form} setForm={setForm}
                           name={'Seleccionar archivo “.jpg”, “.png” o “.pdf” menor a 2 MB (REVERSO)'}
                           accept={'.pdf,.jpg,.png'}
                           onChange={(event) => {
                               setForm({
                                   ...form,
                                   "dni_back": event.target.files[0]
                               });
                           }}/>
            </div>
        </Modal>
    );
}